import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[dpadScrollableHorizontal]'
})
export class DpadScrollableHorizontalDirective {

    @Input() scrollLeftPaddingPx: number = 60;
    @Input() type: 'imageSlider' | 'hero' = 'hero'; // Default to old behavior

    // Properties for the hero behavior
    @HostBinding('style.scroll-behavior')
    smoothScroll: string = 'smooth';

    @HostBinding('style.position')
    position: string = 'relative';

    private currentScroll = 0;

    constructor(private elem: ElementRef) { }

    private get scrollContainer(): HTMLElement {
        const container: HTMLElement = this.elem.nativeElement;
        return container.firstElementChild as HTMLElement || container;
    }

    get isScrollable(): boolean {
        if (this.type === 'imageSlider') {
            const inner = this.scrollContainer;
            const container: HTMLElement = this.elem.nativeElement;
            return inner.scrollWidth > container.clientWidth;
        } else {
            const nElem = this.elem.nativeElement;
            return nElem.scrollWidth > nElem.clientWidth;
        }
    }

    scrollIntoView(element: HTMLElement, type: string | undefined, padding: number | undefined) {
        if (this.type === 'imageSlider') {
            let p = padding ?? 75; // New default for new behavior
            const container: HTMLElement = this.elem.nativeElement;
            const inner: HTMLElement = this.scrollContainer;
            const extraAdjustmentValue = -75;
            const sliderItem = element.closest('.slider-item-v2') as HTMLElement || element;
            const isFirstItem = inner.firstElementChild === sliderItem;
            const adjustment = isFirstItem ? 0 : extraAdjustmentValue;
            let newScrollLeft = 0;
            if (type === 'center') {
                newScrollLeft = sliderItem.offsetLeft - (container.clientWidth / 2) + (sliderItem.offsetWidth / 2) - adjustment;
            } else if (type === 'right' || type === 'bottom') {
                newScrollLeft = sliderItem.offsetLeft - container.clientWidth + sliderItem.offsetWidth + p - adjustment;
            } else {
                newScrollLeft = sliderItem.offsetLeft - p - adjustment;
            }
            newScrollLeft = Math.max(newScrollLeft, 0);
            this.currentScroll = newScrollLeft;
            inner.style.transform = `translateX(-${this.currentScroll}px)`;
        } else {
            let p = padding ?? this.scrollLeftPaddingPx;
            const scrollElem: any = this.elem.nativeElement;
            const elRect = element.getBoundingClientRect();
            const scrollRect = scrollElem.getBoundingClientRect();

            let x = 0;
            if (type === undefined || type === 'top' || type === 'left') {
                const scrollElX = scrollRect.x;
                x = elRect.x - scrollElX;
            }
            if (type === 'center') {
                const scrollElX = (scrollRect.x) + (scrollRect.width / 2) - (elRect.width / 2);
                x = elRect.x - scrollElX;
            }
            if (type === 'bottom' || type === 'right') {
                const scrollElX = (scrollRect.x) + (scrollRect.width) - (elRect.width);
                x = elRect.x - scrollElX;
                p = -p;
            }
            scrollElem.scrollLeft +=  (x - p);
        }
    }
}
